module.exports = __webpack_public_path__ + "img/footer-bg_lg.5b8cab6.webp";